import { Tab, TabList, Tabs, useMediaQuery } from '@chakra-ui/react';
import { RecipeTagsQuery } from '@diamond/shared/types';
import { useState } from 'react';

type RecipeTabs = {
  value: string;
  title: string;
};

type RecipeListTabsProps = {
  currentCategory: RecipeTagsQuery['category'];
  tabs: Array<RecipeTabs>;
  onTabChange: (value: RecipeTabs['value']) => void;
  onTabMouseEnter?: (value: RecipeTabs['value']) => void;
};

export function RecipeListTabs({
  currentCategory,
  tabs,
  onTabChange,
  onTabMouseEnter,
}: RecipeListTabsProps) {
  const defaultIndex = tabs.findIndex((t) => t.value === currentCategory);
  const [tabIndex, setIndexTab] = useState(
    defaultIndex !== -1 ? defaultIndex : 0
  );
  const [isMobile] = useMediaQuery('(max-width: 992px)');

  return (
    <Tabs
      isFitted={isMobile}
      index={tabIndex}
      onChange={(i) => {
        setIndexTab(i);
        onTabChange(tabs[i].value);
      }}
    >
      <TabList borderColor="#D9D9D9" borderBottomWidth="2px">
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            bg="white"
            px={4}
            fontSize={{ base: '12px', md: '14px' }}
            borderColor="#D9D9D9"
            borderBottomWidth="4px"
            color="gray.75"
            _selected={{
              borderColor: '#B80000',
              fontWeight: 'medium',
              color: 'black',
            }}
            _hover={{
              color: 'azure',
            }}
            onMouseEnter={() => onTabMouseEnter?.(tab.value)}
          >
            {tab.title}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}
